module.exports = __webpack_public_path__ + "static/media/hand.3dc07173.jpg";